import { applyTokens } from "../../../utilities/applyTokens.js";
const step = (tokens) => {
    const { stepper } = tokens.component;
    return {
        MuiStep: {
            styleOverrides: {
                root: Object.assign({}, applyTokens(stepper)),
                vertical: Object.assign({}, applyTokens(stepper.vertical)),
            },
        },
        MuiStepLabel: {
            styleOverrides: {
                label: Object.assign(Object.assign({}, applyTokens(stepper.label)), { "&&.Mui-active": Object.assign({}, applyTokens(stepper.label.active)) }),
            },
        },
        MuiStepIcon: {
            styleOverrides: {
                root: {
                    color: stepper.icon.backgroundColor.value,
                    width: stepper.icon.width.value,
                    height: stepper.icon.height.value,
                    "&&.Mui-active": {
                        color: stepper.icon.active.backgroundColor.value,
                    },
                    "&&.Mui-completed ": {
                        color: stepper.icon.completed.backgroundColor.value,
                    },
                },
                text: Object.assign({}, applyTokens(stepper.icon.text)),
            },
        },
    };
};
export default step;
//# sourceMappingURL=step.js.map